import { CustomTabPanel } from "@/erp/sale"
import { a11yProps, EstadosOrdenTrabajoEnumChoice, useTabsFormOnly } from "@/shared"
import { FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui"
import { Tab } from "@mui/material"
import TableAgendaOrdenServicioCorp from "../../../shared/components/TableOrdenServicioCorp/TableOrdenServicioCorp"

export const OrdenServicioCorporativoPage = () => {
  const { handleMethodChange, valueTab } = useTabsFormOnly({})
  return (

    <SingleTableBoxScene title="Orden Servicio Coporativo">
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Asignadas" value={1} {...a11yProps(1)} />
          <Tab label="Reasignadas" value={2} {...a11yProps(2)} />
          <Tab label="Realizadas" value={3} {...a11yProps(3)} />
          <Tab label="Fallidas" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>
      <CustomTabPanel value={valueTab} index={1}>
        <TableAgendaOrdenServicioCorp
          stateAgendamiento={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableAgendaOrdenServicioCorp
          stateAgendamiento={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  )
}
export default OrdenServicioCorporativoPage;